import React, { useMemo } from 'react'
import { Link, Text } from '@pet-notify/ui'
import ErrorMessage, { parseErrorMessage } from 'components/ErrorMessage'

function OrderErrorMessage({ error }: { error: unknown }) {
  const message = useMemo(() => {
    return parseErrorMessage(error)
  }, [error])

  if (message === 'Activation code already used') {
    return (
      <Text mb='3' variant='error'>
        <strong>Your Intellitag code has been activated already.</strong>
        <br />
        <Link href='/'>Sign in and access your Pet Vault</Link>, or for further
        assistance contact us at{' '}
        <a href='mailto:support@petnotify.com'>support@petnotify.com</a>
      </Text>
    )
  } else return <ErrorMessage error={message} />
}

export default OrderErrorMessage
